module.exports = __webpack_public_path__ + "8cd6e05457dd3c189d1c0d942f7da235.svg";